// launcherConfigService.js

import workspace from "./workspace"; 

export const getLauncherConfigs = async () => {
  try {
    const response = await workspace.get(`/launcher-config/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching launcher configs:", error);
    throw error;
  }
};

export const getLauncherConfigById = async (id) => {
  try {
    const response = await workspace.get(`/launcher-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching launcher config with ID ${id}:`, error);
    throw error;
  }
};

export const createLauncherConfig = async (configData) => {
  try {
    const response = await workspace.post(`/launcher-config/`, configData);
    return response.data;
  } catch (error) {
    console.error("Error creating launcher config:", error);
    throw error;
  }
};

export const updateLauncherConfig = async (id, configData) => {
  try {
    const response = await workspace.put(`/launcher-config/${id}/`, configData);
    return response.data;
  } catch (error) {
    console.error(`Error updating launcher config with ID ${id}:`, error);
    throw error;
  }
};

export const deleteLauncherConfig = async (id) => {
  try {
    const response = await workspace.delete(`/launcher-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting launcher config with ID ${id}:`, error);
    throw error;
  }
};
